(function () {
  if (window.TorrasCustomerAttributionLoaded) return;
  window.TorrasCustomerAttributionLoaded = true;

  function getMessageElement(form) {
    var message = form.querySelector('[data-attribution-message]');
    if (message) return message;

    message = document.createElement('div');
    message.setAttribute('data-attribution-message', '');
    message.setAttribute('role', 'status');
    message.style.marginTop = '10px';
    message.style.fontSize = '13px';
    message.style.lineHeight = '1.4';
    form.appendChild(message);
    return message;
  }

  function setMessage(form, text, isError) {
    var message = getMessageElement(form);
    message.textContent = text;
    message.style.color = isError ? '#d32f2f' : '#2e7d32';
  }

  function getEmail(form) {
    var input = form.querySelector('input[name="contact[email]"], input[type="email"]');
    return input ? input.value.trim() : '';
  }

  function isFooterNewsletterForm(form) {
    var tagInput = form.querySelector('input[name="contact[tags]"]');
    var tags = tagInput ? tagInput.value : '';

    return tags.indexOf('newsletter') !== -1 && (
      form.id === 'NewsletterFooter' ||
      form.id === 'ContactFooter' ||
      form.classList.contains('yg-footer-newsletter') ||
      form.classList.contains('footer__newsletter')
    );
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !isFooterNewsletterForm(form)) return;
    if (!window.TORRAS_API_BASE) return;

    event.preventDefault();

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
      return;
    }

    var email = getEmail(form);
    if (!email) {
      setMessage(form, 'Please enter a valid email address.', true);
      return;
    }

    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    var originalButtonText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      if (button.textContent.trim()) button.textContent = 'Submitting...';
    }

    fetch(window.TORRAS_API_BASE + '/api/attribution/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Site': window.TORRAS_SITE || 'us'
      },
      body: JSON.stringify({ email: email, source: 'footer' })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || !data.success) {
            throw new Error(data.error || 'Subscription failed');
          }
          return data;
        });
      })
      .then(function () {
        setMessage(form, 'Thanks for subscribing.', false);
        form.reset();
      })
      .catch(function (error) {
        console.error('[Attribution] Footer subscription failed:', error);
        setMessage(form, 'Subscription failed. Please try again.', true);
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          if (originalButtonText.trim()) button.textContent = originalButtonText;
        }
      });
  });
})();